"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ListWorkflowTemplatesResponse", {
    enumerable: true,
    get: function() {
        return ListWorkflowTemplatesResponse;
    }
});
const _zod = require("zod");
const _responsehelpers = require("../helpers/response-helpers");
const WorkflowTemplateResponseItem = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    name: _zod.z.string(),
    lastUpdate: _zod.z.union([
        _zod.z.date(),
        _zod.z.string()
    ]).nullable(),
    todoCount: _zod.z.number().int()
});
const ListWorkflowTemplatesResponse = _zod.z.object({
    workflowTemplates: _zod.z.array(WorkflowTemplateResponseItem),
    totalCount: _zod.z.number()
});
